import { __awaiter } from "tslib";
import Vue from 'vue';
import { AsideModes } from './interfaces/index';
import ReqAfterKyc from './../kyc-plugs/RegAfterKyc.vue';
import spotAhead from './components/ahead/index.vue';
import spotFolder from './components/spotFolder/index.vue';
import spotItem from './components/spotItem/index.vue';
import spotAside from './components/aside/index.vue';
import { setIndexes, getMarketPairs, findMinimumWithdrawalAmount } from '@/components/pages/spotPage/trade/helpers';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import BASE_CONSTANTS from '@/constants/baseConstants';
import _ from 'lodash';
import moment from 'moment';
let exhangesSocket = null;
function loadBinanceExhangeData(vm, selectedItems = []) {
    return __awaiter(this, void 0, void 0, function* () {
        getMarketPairs().then((response) => {
            const userCoins = vm.base.reduce((arr, curr) => {
                arr.push(...curr.items.map((item) => item.name));
                return arr;
            }, []);
            const allSymbols = Object.keys(response.reduce((arr, curr) => {
                arr[curr.baseAsset] = '';
                return arr;
            }, {}));
            _.remove(allSymbols, (curr) => userCoins.includes(curr));
            vm.availableToPayCoins = allSymbols.sort().reduce((arr, curr, currIndex) => {
                arr.push({
                    name: curr,
                    val: '0',
                    valInUSDT: '0',
                    letConvert: false,
                    letSell: false,
                    locked: false,
                    id: 'available-' + currIndex,
                    folderID: -1,
                    index: currIndex,
                    folderIndex: -1,
                    isFolder: false,
                    selected: selectedItems.includes(curr),
                    inDefaultFolder: false,
                    isDefaultLocked: false,
                    isLastItem: false,
                    minUSDTAmount: 0,
                    stepSize: 0,
                    isAvailableToPay: true
                });
                return arr;
            }, []);
        });
    });
}
function handleMouseMove() {
    const allTargets = document.querySelectorAll('.spot_item-wrapper');
    let findedFolderID = null;
    let checkingCounter = 0;
    while (findedFolderID === null && checkingCounter < allTargets.length) {
        const item = allTargets[checkingCounter];
        if (item.matches(':hover')) {
            findedFolderID = item.dataset.folderId;
        }
        checkingCounter += 1;
    }
    if (findedFolderID !== null) {
        for (let i = 0; i < allTargets.length; i++) {
            if (allTargets[i].dataset.folderId === findedFolderID) {
                allTargets[i].classList.add('spot_item-wrapper--manual-hover');
            }
            else {
                allTargets[i].classList.remove('spot_item-wrapper--manual-hover');
            }
        }
    }
    else {
        for (let i = 0; i < allTargets.length; i++) {
            allTargets[i].classList.remove('spot_item-wrapper--manual-hover');
        }
    }
}
export default Vue.extend({
    name: 'spotPageBody',
    data: () => ({
        isLocked: null,
        preset: {
            asideMode: AsideModes.sell
        },
        searchPhrase: '',
        base: [],
        context: {
            folderInstance: null,
            itemInstance: null,
            folderIsOpened: false,
            itemIsOpened: false,
            x: 0,
            y: 0
        },
        folderIDToRename: null,
        BNBUSDTExchange: '0',
        BTCUSDTExchange: '0',
        loadError: false,
        isRetry: false,
        selectedQuoteAsset: '',
        availableToPayCoins: [],
        findedPairSymbol: {
            name: '',
            marketPrice: ''
        },
        convertPresetRules: {
            available: false,
            convertAfter: null
        },
        paymentData: {
            withdrawalMinAmounts: {},
            canDepositAssets: {},
            isLoading: true
        }
    }),
    computed: {
        asideWalletData() {
            const vm = this;
            const totalUSDTCost = vm.base.reduce((foldersAcc, curr) => {
                foldersAcc += curr.items.reduce((itemsAcc, curr) => {
                    itemsAcc += parseFloat(curr.valInUSDT);
                    return itemsAcc;
                }, 0);
                return foldersAcc;
            }, 0);
            const result = {
                totalUSDTCost,
                items: []
            };
            for (const folder of vm.base) {
                result.items.push(...folder.items.map((item) => {
                    return ({
                        name: item.name,
                        value: parseFloat(item.valInUSDT) / totalUSDTCost * 100,
                        quantity: parseFloat(item.val)
                    });
                }));
            }
            return result;
        },
        selectedItems() {
            const vm = this;
            const reducedAvailableCoins = vm.availableToPayCoins.filter((item) => item.selected);
            return vm.base.reduce((acc, curr) => {
                acc.push(...curr.items.filter((item) => item.selected));
                return acc;
            }, [...reducedAvailableCoins]);
        },
        selectedFolders() {
            const vm = this;
            return vm.base.filter((folder) => folder.selected);
        },
        haveItems() {
            const vm = this;
            for (const folder of vm.base) {
                if (folder.items.length > 0)
                    return true;
            }
            return false;
        },
        reducedItems() {
            const vm = this;
            const result = vm.base.reduce((arr, curr) => {
                if (!curr.defaultFolder) {
                    const transformedFolder = [];
                    if (!vm.searchPhrase.length) {
                        transformedFolder.push({
                            name: curr.name,
                            index: curr.index,
                            id: curr.id,
                            opened: curr.opened,
                            isFolder: curr.isFolder,
                            locked: curr.locked,
                            empty: curr.empty,
                            selected: curr.selected,
                            defaultFolder: curr.defaultFolder,
                            letLockFolder: !curr.items.every((item) => item.isDefaultLocked)
                        });
                        if (curr.opened) {
                            transformedFolder.push(...curr.items.map((item, index) => {
                                item.isLastItem = index + 1 === curr.items.length;
                                return item;
                            }));
                        }
                    }
                    else {
                        const filtredItems = curr.items.filter((item) => {
                            return item.name.toLowerCase().indexOf(vm.searchPhrase.toLowerCase()) !== -1;
                        });
                        filtredItems.map((item, index) => {
                            item.isLastItem = index + 1 === filtredItems.length;
                            return item;
                        });
                        if (filtredItems.length) {
                            transformedFolder.push({
                                name: curr.name,
                                index: curr.index,
                                id: curr.id,
                                opened: curr.opened,
                                isFolder: curr.isFolder,
                                locked: curr.locked,
                                empty: curr.empty,
                                selected: curr.selected,
                                defaultFolder: curr.defaultFolder,
                                letLockFolder: !curr.items.every((item) => item.isDefaultLocked)
                            });
                            transformedFolder.push(...filtredItems);
                        }
                    }
                    arr.push(...transformedFolder);
                }
                return arr;
            }, []);
            const findedDefaultFolderIndex = vm.base.findIndex((folder) => folder.defaultFolder);
            if (findedDefaultFolderIndex >= 0) {
                if (vm.searchPhrase.length === 0) {
                    result.push(...vm.base[findedDefaultFolderIndex].items);
                }
                else {
                    const curr = vm.base[findedDefaultFolderIndex];
                    const filtredItems = curr.items.filter((item) => {
                        return item.name.toLowerCase().indexOf(vm.searchPhrase.toLowerCase()) !== -1;
                    });
                    if (filtredItems.length) {
                        result.push(...filtredItems);
                    }
                }
            }
            return result;
        },
        reducedAvailableItems() {
            const vm = this;
            if (!vm.isRetry && !vm.loadError)
                return vm.availableToPayCoins.filter((item) => item.name.toLowerCase().indexOf(vm.searchPhrase.toLowerCase()) !== -1);
            return [];
        },
        letMoveFolderDown() {
            const vm = this;
            if (vm.context.folderIsOpened) {
                return (index) => !vm.base[index + 1].defaultFolder;
            }
            else
                return false;
        },
        availableToMoveFolders() {
            const vm = this;
            if (vm.context.itemIsOpened) {
                return vm.base
                    .filter((folder) => folder.index !== vm.context.itemInstance.folderIndex && !folder.defaultFolder)
                    .map((folder) => ({ name: folder.name, folderIndex: folder.index }));
            }
            else if (vm.selectedItems.length) {
                return vm.base
                    .filter((folder) => folder.index !== vm.selectedItems[0].folderIndex && !folder.defaultFolder)
                    .map((folder) => ({ name: folder.name, folderIndex: folder.index }));
            }
            else
                return [];
        },
        availableToConvertCoins() {
            const vm = this;
            return vm.base.reduce((acc, curr) => {
                curr.items.forEach((item) => {
                    if (item.letConvert && !item.locked)
                        acc.push({ name: item.name, id: item.id, val: parseFloat(item.valInUSDT) / parseFloat(vm.BNBUSDTExchange) });
                });
                return acc;
            }, []);
        },
        availableToSellCoins() {
            const vm = this;
            return vm.base.reduce((acc, curr) => {
                curr.items.forEach((item) => {
                    if (item.letSell && !item.locked)
                        acc.push({ name: item.name, id: item.id, amount: item.val, valInUSDT: item.valInUSDT });
                });
                return acc;
            }, []);
        },
        isSelectedElBlocked() {
            var _a;
            const vm = this;
            const selectedElement = (_a = vm.selectedItems[0]) !== null && _a !== void 0 ? _a : vm.selectedFolders[0];
            return selectedElement && selectedElement.locked;
        },
        selectedQuoteAssetQuantity() {
            const vm = this;
            for (const folder of vm.base) {
                for (const item of folder.items) {
                    if (item.name === vm.selectedQuoteAsset)
                        return parseFloat(item.val);
                }
            }
            return 0;
        }
    },
    watch: {
        base: {
            handler(v) {
                v.forEach((folder) => {
                    if (!folder.defaultFolder) {
                        if (folder.items.length) {
                            folder.locked = folder.items.filter((item) => item.locked).length === folder.items.length;
                            folder.empty = false;
                        }
                        else {
                            folder.empty = true;
                        }
                    }
                });
                setTimeout(handleMouseMove, 0);
            },
            deep: true
        },
        'context.folderIsOpened'(v) {
            if (!v)
                this.context.folderInstance = null;
        },
        'context.itemIsOpened'(v) {
            if (!v)
                this.context.itemInstance = null;
        }
    },
    methods: {
        MAClickHandler(name) {
            this.$router.push({ name: 'mainPage', query: { coinToTransfer: name } });
        },
        hanldeClickConvertItem(item) {
            const vm = this;
            vm.selectedItems.forEach((item) => {
                vm.base[item.folderIndex].items[item.index].selected = false;
            });
            vm.selectedFolders.forEach((folder) => {
                vm.base[folder.index].selected = false;
            });
            if (item.locked) {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: vm.$t('spotPage.popups.titles.convertForBNB', { name: item.name }),
                    content: vm.$t('spotPage.popups.content.toConvertToResetBlock', { name: item.name }),
                    slot: {},
                    actions: [
                        {
                            title: vm.$t('spotPage.popups.common.ok'),
                            isAccent: true,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
            }
            else {
                if (vm.convertPresetRules.available) {
                    const availableToBurn = vm.$options.filters.formatMoney(parseFloat(item.val));
                    vm.$store.dispatch('popupModule/openPopup', {
                        type: ActivePopupTypes.action,
                        letDefaultClose: true,
                        title: vm.$t('spotPage.popups.titles.convertToBNB', { name: item.name }),
                        content: vm.$t('spotPage.popups.content.availableToConvert', { availableToBurn, name: item.name }),
                        slot: {
                            name: 'singleConvertConfirmSpotPopupChunk',
                            data: {},
                            on: {}
                        },
                        actions: [
                            {
                                title: vm.$t('spotPage.popups.common.convert'),
                                isAccent: true,
                                callback() {
                                    return __awaiter(this, void 0, void 0, function* () {
                                        vm.$store.commit('popupModule/setClosed');
                                        const response = yield vm.services.mainService.convertInBNBSpot({ ids: [item.id] });
                                        if (response.success) {
                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                title: vm.$t('spotPage.alerts.titles.success'),
                                                type: 'success',
                                                autoDelete: true,
                                                content: vm.$t('spotPage.alerts.content.successfulConverted', { name: item.name })
                                            });
                                            vm.init();
                                        }
                                        else {
                                            vm.$store.dispatch('alertsBus/openAlert', {
                                                title: vm.$t('spotPage.alerts.titles.error'),
                                                type: 'error',
                                                autoDelete: true,
                                                content: vm.$t('spotPage.alerts.content.successfulConverted', { name: item.name })
                                            });
                                        }
                                    });
                                }
                            },
                            {
                                title: vm.$t('spotPage.popups.common.cancel'),
                                isAccent: false,
                                callback() { vm.$store.commit('popupModule/setClosed'); }
                            }
                        ]
                    });
                }
                else {
                    vm.$store.dispatch('popupModule/openPopup', {
                        type: ActivePopupTypes.action,
                        letDefaultClose: true,
                        title: vm.$t('spotPage.popups.titles.convertForBNB', { name: item.name }),
                        content: vm.$t('spotPage.popups.content.nextConvertPossible', { from: moment(vm.convertPresetRules.convertAfter).format('DD.MM.YYYY'), to: moment(vm.convertPresetRules.convertAfter).format('HH:mm') }),
                        slot: {},
                        actions: [
                            {
                                title: vm.$t('spotPage.popups.common.ok'),
                                isAccent: true,
                                callback() {
                                    vm.$store.commit('popupModule/setClosed');
                                }
                            }
                        ]
                    });
                }
            }
        },
        handleMoveItem(item, newFolderIndex) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.moveItemSpot({ items: [item.id], index: vm.base[newFolderIndex].items.length }, vm.base[newFolderIndex].id);
                if (response.success) {
                    vm.base[newFolderIndex].items.push(...vm.base[item.folderIndex].items.splice(item.index, 1));
                    vm.context.itemIsOpened = false;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.coinMoved')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.failedMovedCoin')
                    });
                }
                setIndexes(vm);
            });
        },
        handleDeleteItem(item) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const defaultFolderIndex = vm.base.findIndex((folder) => folder.defaultFolder);
                const response = yield vm.services.mainService.moveItemSpot({ items: [item.id], index: vm.base[defaultFolderIndex].items.length }, vm.base[defaultFolderIndex].id);
                if (response.success) {
                    vm.base[defaultFolderIndex].items.push(...vm.base[item.folderIndex].items.splice(item.index, 1));
                    vm.context.itemIsOpened = false;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.coinDeleted')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.coinDeletedFailed')
                    });
                }
                setIndexes(vm);
            });
        },
        handleMoveFolder(direction) {
            const vm = this;
            if (direction === 'up') {
                vm.base.splice(vm.context.folderInstance.index - 1, 0, vm.base.splice(vm.context.folderInstance.index, 1)[0]);
            }
            else {
                vm.base.splice(vm.context.folderInstance.index + 1, 0, vm.base.splice(vm.context.folderInstance.index, 1)[0]);
            }
            setIndexes(vm);
            vm.context.folderIsOpened = false;
        },
        handleDeleteFolder(index) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.deleteFolderSpot(null, vm.base[index].id);
                if (response.success) {
                    const baseFolderIndex = vm.base.findIndex((folder) => folder.defaultFolder);
                    vm.base[baseFolderIndex].items.push(...vm.base[index].items);
                    vm.base.splice(index, 1);
                    vm.context.folderIsOpened = false;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.folderDeleted')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.coinDeletedFailed')
                    });
                }
                setIndexes(vm);
            });
        },
        handleClickRenameFolder(folderIndex) {
            const vm = this;
            vm.base[folderIndex].selected = false;
            vm.folderIDToRename = vm.base[folderIndex].id;
        },
        handleFolderRename(newName, folder) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.patchFolderSpot({ name: newName }, folder.id);
                if (response.success) {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.folderRenamed')
                    });
                    vm.base[folder.index].name = newName;
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.folderRenameFailed')
                    });
                }
                vm.folderIDToRename = null;
            });
        },
        createFolder() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.createFolderSpot({
                    name: vm.$t('spotPage.aside.newFolder')
                });
                if (response.success) {
                    const newFolder = response.data;
                    newFolder.empty = true;
                    newFolder.selected = false;
                    vm.base.unshift(newFolder);
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.folderCreated')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.folderCreateFailed')
                    });
                }
                setIndexes(vm);
            });
        },
        handleFolderFreeClick(folder) {
            const vm = this;
            if (!this.miw(960))
                return;
            if (vm.selectedItems.length) {
                vm.selectedItems.forEach((item) => {
                    if (!item.isAvailableToPay) {
                        vm.base[item.folderIndex].items[item.index].selected = false;
                    }
                    else {
                        vm.availableToPayCoins[item.index].selected = false;
                    }
                });
            }
            if (vm.selectedFolders.length) {
                vm.selectedFolders.forEach((spotFolder) => {
                    if (spotFolder.id !== folder.id)
                        vm.base[spotFolder.index].selected = false;
                });
            }
            vm.base[folder.index].selected = !folder.selected;
        },
        handleItemFreeClick(item) {
            const vm = this;
            if (vm.selectedFolders.length) {
                vm.selectedFolders.forEach((folder) => {
                    vm.base[folder.index].selected = false;
                });
            }
            if (vm.selectedItems.length) {
                vm.selectedItems.forEach((spotItem) => {
                    if (!spotItem.isAvailableToPay) {
                        if (spotItem.id !== item.id)
                            vm.base[spotItem.folderIndex].items[spotItem.index].selected = false;
                    }
                    else {
                        if (spotItem.id !== item.id)
                            vm.availableToPayCoins[spotItem.index].selected = false;
                    }
                });
            }
            if (!item.isAvailableToPay) {
                vm.base[item.folderIndex].items[item.index].selected = !item.selected;
            }
            else {
                vm.availableToPayCoins[item.index].selected = !item.selected;
            }
        },
        handleRightClickOnItem(event, item) {
            const vm = this;
            vm.context.folderIsOpened = false;
            vm.context.x = event.clientX + 30;
            vm.context.y = event.clientY;
            vm.context.itemInstance = item;
            vm.context.itemIsOpened = true;
        },
        handleRightClickOnFolder(event, folder) {
            const vm = this;
            vm.context.itemIsOpened = false;
            vm.context.x = event.clientX + 30;
            vm.context.y = event.clientY;
            vm.context.folderInstance = folder;
            vm.context.folderIsOpened = true;
        },
        handleClickLockItem(item) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.patchItemSpot({ locked: !item.locked }, item.id);
                if (response.success) {
                    if (item.isDefaultLocked)
                        return;
                    vm.base[item.folderIndex].items[item.index].locked = !vm.base[item.folderIndex].items[item.index].locked;
                    vm.context.itemIsOpened = false;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'info',
                        autoDelete: true,
                        content: item.locked ? vm.$t('spotPage.alerts.content.coinBlocked') : vm.$t('spotPage.alerts.content.coinUnblocked')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: item.locked ? vm.$t('spotPage.alerts.content.coinUnblockFailed') : vm.$t('spotPage.alerts.content.coinBlockFailed')
                    });
                }
            });
        },
        handleClickLockFolder(folder) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.patchFolderSpot({ locked: !folder.locked }, folder.id);
                if (response.success) {
                    if (vm.base[folder.index].items.length) {
                        const findedNotLockedItemIndex = vm.base[folder.index].items.findIndex((item) => !item.locked);
                        if (findedNotLockedItemIndex < 0) {
                            vm.base[folder.index].locked = false;
                            folder.locked = false;
                            vm.base[folder.index].items.forEach((item) => { if (!item.isDefaultLocked)
                                item.locked = false; });
                        }
                        else {
                            vm.base[folder.index].locked = true;
                            folder.locked = true;
                            vm.base[folder.index].items.forEach((item) => { item.locked = true; });
                        }
                    }
                    else {
                        vm.base[folder.index].locked = !folder.locked;
                    }
                    vm.context.folderIsOpened = false;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: !folder.locked ? vm.$t('spotPage.alerts.content.folderUnblocked') : vm.$t('spotPage.alerts.content.folderBlocked')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: folder.locked ? vm.$t('spotPage.alerts.content.failedToUnblockFolder') : vm.$t('spotPage.alerts.content.failedToBlockFolder')
                    });
                }
            });
        },
        handleClickToggleOpen(folder) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.patchFolderSpot({ opened: !folder.opened }, folder.id);
                if (response.success) {
                    const index = vm.base.findIndex((folderItem) => folderItem.id === folder.id);
                    vm.base[index].opened = !folder.opened;
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: folder.opened ? vm.$t('spotPage.alerts.content.failedToCollapseFolder') : vm.$t('spotPage.alerts.content.failedToExpandFolder')
                    });
                }
            });
        },
        handleClickConvertCoins(coins) {
            const vm = this;
            vm.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: vm.$t('spotPage.popups.titles.convertConfirmation'),
                content: coins.length > 1 ? vm.$t('spotPage.popups.content.areSureToConvertSelCoin') : vm.$t('spotPage.popups.content.areSureToConvertSelCoins'),
                actions: [
                    {
                        title: vm.$t('spotPage.popups.common.cancel'),
                        isAccent: false,
                        callback: () => { vm.$store.commit('popupModule/setClosed'); }
                    },
                    {
                        title: vm.$t('spotPage.popups.common.confirm'),
                        isAccent: true,
                        callback: () => {
                            vm.$store.commit('popupModule/setClosed');
                            vm.convertToBNB(coins);
                        }
                    }
                ]
            });
        },
        handleClickSellCoins(coins) {
            const vm = this;
            vm.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: vm.$t('spotPage.popups.titles.convertConfirmation'),
                content: coins.length > 1 ? vm.$t('spotPage.popups.content.areSureToConvertSelCoinUSDT') : vm.$t('spotPage.popups.content.areSureToConvertSelCoinsUSDT'),
                actions: [
                    {
                        title: vm.$t('spotPage.popups.common.cancel'),
                        isAccent: false,
                        callback: () => { vm.$store.commit('popupModule/setClosed'); }
                    },
                    {
                        title: vm.$t('spotPage.popups.common.confirm'),
                        isAccent: true,
                        callback: () => {
                            vm.$store.commit('popupModule/setClosed');
                            vm.sellCoins(coins);
                        }
                    }
                ]
            });
        },
        handleClickSellAvailable() {
            const vm = this;
            vm.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: vm.$t('spotPage.popups.titles.sellAllForUSDT'),
                content: vm.$t('spotPage.popups.content.availableToSell'),
                slot: {
                    name: 'massSellConfirmSpotPopupChunk',
                    data: {
                        items: vm.availableToSellCoins
                    }
                },
                actions: [
                    {
                        title: vm.$t('spotPage.popups.common.confirm'),
                        isAccent: true,
                        callback: () => {
                            vm.$store.commit('popupModule/setClosed');
                            vm.sellCoins(vm.availableToSellCoins.map((item) => item.id + ''));
                        }
                    },
                    {
                        title: vm.$t('spotPage.popups.common.cancel'),
                        isAccent: false,
                        callback: () => { vm.$store.commit('popupModule/setClosed'); }
                    }
                ]
            });
        },
        handleClickConvertAvailable() {
            const vm = this;
            if (vm.convertPresetRules.available) {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: vm.$t('spotPage.popups.titles.sellAllForBNB'),
                    content: vm.$t('spotPage.popups.content.availableToConvertValues'),
                    slot: {
                        name: 'massConvertConfirmSpotPopupChunk',
                        data: {
                            items: vm.availableToConvertCoins
                        },
                        on: {}
                    },
                    actions: [
                        {
                            title: vm.$t('spotPage.popups.common.confirm'),
                            isAccent: true,
                            callback: () => {
                                vm.$store.commit('popupModule/setClosed');
                                vm.convertToBNB(vm.availableToConvertCoins.map((item) => +item.id));
                            }
                        },
                        {
                            title: vm.$t('spotPage.popups.common.cancel'),
                            isAccent: false,
                            callback: () => { vm.$store.commit('popupModule/setClosed'); }
                        }
                    ]
                });
            }
            else {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: vm.$t('spotPage.popups.titles.conversationForBNB'),
                    content: vm.$t('spotPage.popups.content.nextConvertPossible', { from: moment(vm.convertPresetRules.convertAfter).format('DD.MM.YYYY'), to: moment(vm.convertPresetRules.convertAfter).format('HH:mm') }),
                    slot: {},
                    actions: [
                        {
                            title: vm.$t('spotPage.popups.common.ok'),
                            isAccent: true,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
            }
        },
        convertToBNB(coinsIDs) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.convertInBNBSpot({ ids: coinsIDs });
                if (response.success) {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.convertSuccess')
                    });
                    vm.init();
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('spotPage.alerts.content.convertFailed')
                    });
                }
            });
        },
        sellCoins(coins) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const response = yield vm.services.mainService.sellCoinsSpot({ data: coins });
                if (coins.length === 1) {
                    if (response.success) {
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('spotPage.alerts.titles.success'),
                            type: 'success',
                            autoDelete: true,
                            content: coins.length > 1 ? vm.$t('spotPage.alerts.content.coinsClosed') : vm.$t('spotPage.alerts.content.coinClosed')
                        });
                        vm.init();
                    }
                    else {
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('spotPage.alerts.titles.error'),
                            type: 'error',
                            autoDelete: true,
                            content: coins.length > 1 ? vm.$t('spotPage.alerts.content.failedToCloseCoins') : vm.$t('spotPage.alerts.content.failedToCloseCoin')
                        });
                    }
                }
                else {
                    if (response.success) {
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('spotPage.alerts.titles.success'),
                            type: 'success',
                            autoDelete: true,
                            content: vm.$t('spotPage.alerts.content.allAvailableCoinsSold')
                        });
                        vm.init();
                    }
                    else {
                        if (response.data.data.length && response.data.errors.length) {
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('spotPage.alerts.titles.attention'),
                                type: 'info',
                                autoDelete: true,
                                content: vm.$t('spotPage.alerts.content.someCoinsSellFailed')
                            });
                            vm.init();
                        }
                        else if (!response.data.data.length) {
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('spotPage.alerts.titles.error'),
                                type: 'error',
                                autoDelete: true,
                                content: vm.$t('spotPage.alerts.content.failedToSellAnyCoin')
                            });
                        }
                    }
                }
            });
        },
        loadPaymentData() {
            return __awaiter(this, void 0, void 0, function* () {
                this.paymentData.isLoading = true;
                const response = yield this.services.mainService.getTransfersPaymentData();
                if (response.success) {
                    const withdrawableAssets = Object.keys(response.data.withdraw);
                    withdrawableAssets.forEach(key => {
                        this.paymentData.withdrawalMinAmounts[key] = findMinimumWithdrawalAmount(response.data.withdraw[key]);
                    });
                    this.paymentData.canDepositAssets = response.data.depositAddress;
                }
                this.paymentData.isLoading = false;
            });
        },
        init(isPostInit = false) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                let selectedItems = [];
                if (isPostInit) {
                    selectedItems = vm.selectedItems.map((item) => item.name);
                }
                vm.isRetry = true;
                vm.loadError = false;
                this.loadPaymentData();
                const aheadSuccess = (_a = vm.$refs.ahead) === null || _a === void 0 ? void 0 : _a.init();
                const response = yield vm.services.mainService.getSpotPreset(null);
                if (response.success) {
                    vm.base = response.data.map((folder) => {
                        folder.selected = false;
                        folder.empty = folder.items.length > 0;
                        folder.items.map((item) => {
                            item.selected = false;
                            item.minUSDTAmount = item.minUsdtAmount;
                            item.isAvailableToPay = false;
                            item.letConvert = BASE_CONSTANTS.FIAT_LIST.includes(item.name) ? false : item.letConvert;
                            delete item.minUsdtAmount;
                            return item;
                        });
                        return folder;
                    });
                    vm.base.forEach((folder) => {
                        folder.items.forEach((item) => {
                            item.selected = selectedItems.includes(item.name);
                        });
                    });
                    setIndexes(vm);
                }
                vm.isRetry = false;
                vm.isLocked = response.status === 423;
                if (vm.isLocked)
                    return;
                this.loadError = aheadSuccess ? !(response.success && (yield aheadSuccess)) : !response.success;
                loadBinanceExhangeData(vm, selectedItems);
            });
        }
    },
    beforeRouteLeave(from, to, next) {
        if (exhangesSocket) {
            exhangesSocket.close();
            exhangesSocket = null;
        }
        next();
    },
    mounted() {
        const vm = this;
        vm.init();
        window.onmousemove = handleMouseMove;
        window.addEventListener('resize', () => {
            if (!vm.isTouch && vm.miw(960)) {
                window.onmousemove = handleMouseMove;
            }
            else {
                window.onmousemove = null;
            }
        });
        exhangesSocket = new WebSocket('wss://stream.binance.com:9443/ws/!ticker@arr');
        exhangesSocket.onmessage = function (event) {
            var _a, _b, _c, _d;
            const data = JSON.parse(event.data);
            // c - current price
            // s - symbol
            vm.base.forEach((folder) => {
                folder.items.forEach((item) => {
                    if (item.name.toUpperCase() !== 'USDT') {
                        const currCoin = data.find((dataArr) => dataArr.s === item.name.toUpperCase() + 'USDT');
                        if (currCoin) {
                            vm.base[item.folderIndex].items[item.index].valInUSDT = parseFloat(currCoin.c) * parseFloat(item.val) + '';
                        }
                    }
                });
            });
            vm.BNBUSDTExchange = (_b = (_a = data.find((item) => item.s === 'BNBUSDT')) === null || _a === void 0 ? void 0 : _a.c) !== null && _b !== void 0 ? _b : '0';
            vm.BTCUSDTExchange = (_d = (_c = data.find((item) => item.s === 'BTCUSDT')) === null || _c === void 0 ? void 0 : _c.c) !== null && _d !== void 0 ? _d : '0';
            if (vm.findedPairSymbol.name.length) {
                const findedExchangePairSymbol = data.find((item) => item.s === vm.findedPairSymbol.name);
                if (findedExchangePairSymbol) {
                    vm.findedPairSymbol.marketPrice = findedExchangePairSymbol.c;
                }
            }
        };
    },
    beforeDestroy() {
        window.onmousemove = null;
    },
    components: {
        ReqAfterKyc,
        spotAhead,
        spotFolder,
        spotItem,
        spotAside
    }
});
